// M8.2 Runs consolidation flag.
//
// Env var: VITE_RUNS_V2_ENABLED. Per 2026-10-30 M7/M8 amendment §4.8
// the /v2/runs group has this one flag. Strict `=== 'true'`, default
// OFF. Unset, 'false', '1', 'yes', 'TRUE', and any other value stay OFF.
//
// Flag off: App.tsx does not register /v2/runs/*. The catch-all is
// RootRedirect: an authenticated session goes to /home. There is no
// dedicated 404 page.
//
// Flag on: one splat route renders this surface. In-page child routes
// cover the list and the detail paths. Workflow definitions are
// super-admin only.

export function isRunsV2Enabled(): boolean {
  return import.meta.env.VITE_RUNS_V2_ENABLED === 'true';
}
